import React from 'react';
import { Helmet } from 'react-helmet-async';
import { usePortalContext } from '../app/AppContext';


interface Props {
  children: string
}


export const RentalPageTitleHelmet = (props: Props) => {
  const context = usePortalContext();
  return (
    <Helmet>
      <title>{context.portal.title} Rental Application - {props.children}</title>
    </Helmet>
  )
}